<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-app-bar fixed app>
        <v-app-bar-nav-icon @click="menuSelected"/>
        <v-toolbar-title>
            {{ $route.meta.title }}
        </v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items>
            <v-img :src="require('../assets/images/logo b text.svg')" alt="Logo" width="192" height="42" class="my-2"/>
        </v-toolbar-items>
    </v-app-bar>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default
    {
        name: 'toolbar',
        computed:
        {
            ...mapState('auth', { drawer: state => state.navDrawerToggle })
        },
        methods:
        {
            ...mapMutations('auth', ['SET_NAV_DRAWER_TOGGLE']),
            menuSelected()
            {
                this.SET_NAV_DRAWER_TOGGLE(!this.drawer)
            }
        }
    }
</script>

<style scoped>
</style>